// Curated, categorized portfolio. Aspect ratios match originals for layout planning.
// w/h pairs are used only for layout hints (object-fit: cover handles the rest).

export const CATEGORIES = [
  { id: "todas", label: "Todas" },
  { id: "pergolas", label: "Pérgolas" },
  { id: "construccion", label: "Construcción" },
  { id: "exteriores", label: "Exteriores" },
  { id: "interiores", label: "Interiores" },
];

export const PHOTOS = [
  // Pérgolas — featured
  {
    id: "p1",
    src: "/photos/pergola_01.jpg",
    webp: "/photos/pergola_01.webp",
    alt: "Pérgola terminada cubriendo entrada vehicular",
    category: "pergolas",
    w: 1280,
    h: 960,
    span: "tall",
  },
  {
    id: "p2",
    src: "/photos/pergola_02.jpg",
    webp: "/photos/pergola_02.webp",
    alt: "Pérgola moderna con techo de listones de madera",
    category: "pergolas",
    w: 1600,
    h: 900,
    span: "wide",
  },
  {
    id: "p3",
    src: "/photos/pergola_03.jpg",
    webp: "/photos/pergola_03.webp",
    alt: "Pérgola finalizada con jardín",
    category: "pergolas",
    w: 1280,
    h: 960,
  },
  {
    id: "p4",
    src: "/photos/pergola_04.jpg",
    webp: "/photos/pergola_04.webp",
    alt: "Pérgola larga que acompaña el frente del edificio",
    category: "pergolas",
    w: 1080,
    h: 1193,
    span: "tall",
  },
  {
    id: "p5",
    src: "/photos/pergola_05.jpg",
    webp: "/photos/pergola_05.webp",
    alt: "Vista interior de pérgola con iluminación cálida",
    category: "pergolas",
    w: 1280,
    h: 960,
  },
  {
    id: "p6",
    src: "/photos/pergola_06.jpg",
    webp: "/photos/pergola_06.webp",
    alt: "Galería cubierta con ventiladores y muebles",
    category: "pergolas",
    w: 1280,
    h: 960,
  },
  {
    id: "p7",
    src: "/photos/pergola_07.jpg",
    webp: "/photos/pergola_07.webp",
    alt: "Vista cenital de pérgola de madera",
    category: "pergolas",
    w: 1600,
    h: 900,
    span: "wide",
  },
  {
    id: "p8",
    src: "/photos/pergola_08.jpg",
    webp: "/photos/pergola_08.webp",
    alt: "Quincho cubierto con techo de madera",
    category: "pergolas",
    w: 1280,
    h: 960,
  },
  {
    id: "p9",
    src: "/photos/pergola_09.jpg",
    webp: "/photos/pergola_09.webp",
    alt: "Detalle de cielo raso de madera con luces",
    category: "pergolas",
    w: 1280,
    h: 960,
  },

  // Construcción / proceso
  {
    id: "c1",
    src: "/photos/construccion_01.jpg",
    webp: "/photos/construccion_01.webp",
    alt: "Equipo instalando estructura de pérgola",
    category: "construccion",
    w: 1280,
    h: 960,
  },
  {
    id: "c2",
    src: "/photos/construccion_02.jpg",
    webp: "/photos/construccion_02.webp",
    alt: "Trabajadores montando pérgola sobre jardín",
    category: "construccion",
    w: 1280,
    h: 720,
    span: "wide",
  },
  {
    id: "c3",
    src: "/photos/construccion_03.jpg",
    webp: "/photos/construccion_03.webp",
    alt: "Instalación de pérgola en obra",
    category: "construccion",
    w: 1280,
    h: 720,
    span: "wide",
  },
  {
    id: "c4",
    src: "/photos/construccion_04.jpg",
    webp: "/photos/construccion_04.webp",
    alt: "Pérgola en construcción con mampostería",
    category: "construccion",
    w: 1280,
    h: 960,
  },

  // Exteriores
  {
    id: "e1",
    src: "/photos/exterior_01.jpg",
    webp: "/photos/exterior_01.webp",
    alt: "Frente de vivienda con pérgola integrada",
    category: "exteriores",
    w: 1280,
    h: 960,
  },
  {
    id: "e2",
    src: "/photos/exterior_02.jpg",
    webp: "/photos/exterior_02.webp",
    alt: "Cochera moderna cubierta",
    category: "exteriores",
    w: 540,
    h: 1200,
    span: "tall",
  },
  {
    id: "e3",
    src: "/photos/exterior_03.jpg",
    webp: "/photos/exterior_03.webp",
    alt: "Alero exterior con cielo raso de madera",
    category: "exteriores",
    w: 1200,
    h: 900,
  },
  {
    id: "e4",
    src: "/photos/exterior_04.jpg",
    webp: "/photos/exterior_04.webp",
    alt: "Fachada con rampa y alero de listones",
    category: "exteriores",
    w: 865,
    h: 1280,
    span: "tall",
  },

  // Interiores / detalles
  {
    id: "i1",
    src: "/photos/interior_01.jpg",
    webp: "/photos/interior_01.webp",
    alt: "Baño con terminaciones de calidad",
    category: "interiores",
    w: 564,
    h: 752,
  },
  {
    id: "d1",
    src: "/photos/detalle_01.jpg",
    webp: "/photos/detalle_01.webp",
    alt: "Detalle de listones de madera del cielo raso",
    category: "pergolas",
    w: 878,
    h: 1280,
    span: "tall",
  },
];
